module.exports = __webpack_public_path__ + "img/lg_ring_y_s_0_null@2x.3a783c8d.png";